import { makeAutoObservable, runInAction } from 'mobx'

import { GlobalCopyApi } from '../api'
import { GlobalCopy } from '../types'

import { GlobalStore } from './GlobalStore'

export class GlobalCopyStore {
  globalStore: GlobalStore
  api: GlobalCopyApi = new GlobalCopyApi('/', '')

  copy: GlobalCopy = {} as GlobalCopy
  featureNamespace = 'experiences'

  isInitialized = false

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.api = new GlobalCopyApi(
      globalStore.endpoint,
      globalStore.sessionToken,
      globalStore.onError,
    )

    makeAutoObservable(this)
  }

  loadCopy = async () => {
    await this.getCopy(this.featureNamespace)

    runInAction(() => {
      this.isInitialized = true
    })
  }

  getCopy = async (namespace: string, translationKey: string = '') => {
    try {
      const newCopy = await this.api.getGlobalCopy(namespace, translationKey)

      runInAction(() => {
        this.copy = newCopy[namespace]
      })
    } catch (error) {
      console.error('Error occurred while fetching copy:', error)
      this.globalStore.captureException(error, { store: 'GlobalCopyStore' })
    }
  }
}
